'use client';
import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

// import required modules
import Styles from '@/app/_components/title-desc-block/TitleDescBlock.module.scss';

const TitleDescBlock = ({
  title = '',
  text = '',
}: {
  title?: string;
  text?: string;
}) => {
  return (
    <>
      <Box className={Styles.blockDetails}>
        <Box className={Styles.headingElement}>
          <Heading
            as="h4"
            className={Styles.titleMd}
            marginBottom={{ base: 4, md: 5 }}
          >
            {title}
          </Heading>
          <Box
            className={Styles.titleText}
            dangerouslySetInnerHTML={{ __html: text }}
          ></Box>
        </Box>
      </Box>
    </>
  );
};

export default TitleDescBlock;
